import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { ILeanBrandTile as IRealLeanBrandTile } from "@faire/web-api--source/indigofair/data/ILeanBrandTile";
import { getLeadTimeText } from "@faire/retailer/lib/getLeadTimeText";
export var ILeanBrandTile;
(function(ILeanBrandTile) {
    ILeanBrandTile.fromLeanProductTileBrand = function(brand) {
        if (!brand) {
            return undefined;
        }
        return {
            brand: IRealLeanBrandTile.IBrand.build({
                name: brand.name,
                token: brand.token,
                squared_image: brand.squared_image,
                free_shipping_reason: brand.free_shipping_reason,
                minimum_order_amount: brand.minimum_order_amount,
                is_top_shop: brand.is_top_shop,
                is_highlighted_brand_for_promotional_event: brand.is_highlighted_brand_for_promotional_event,
                based_in: brand.based_in,
                ships_from_country: brand.ships_from_country,
                based_in_country: brand.based_in,
                profile_image: brand.profile_image,
                insider_benefits: brand.insider_benefits,
                insider_label: brand.insider_label,
                active_products_count: brand.active_products_count,
                based_in_country_message: brand.based_in_country_message,
                region_flag_image: brand.region_flag_image,
                avg_brand_review_rating: brand.avg_brand_review_rating
            }),
            promo_text: undefined,
            images: [],
            brand_promo_label: undefined,
            featured_brand_promo_label: undefined,
            lead_time_text: undefined
        };
    };
    ILeanBrandTile.fromIBrandTile = function(brand) {
        if (!brand) {
            return undefined;
        }
        return {
            brand: IRealLeanBrandTile.IBrand.build({
                name: brand.name,
                token: brand.token,
                squared_image: brand.image,
                is_following: brand.is_following,
                free_shipping_reason: brand.free_shipping_reason,
                minimum_order_amount: brand.minimum_order_amount,
                has_new_products: brand.has_new_products,
                is_top_shop: brand.is_top_shop,
                is_highlighted_brand_for_promotional_event: brand.is_highlighted_brand_for_promotional_event,
                based_in: brand.based_in_country,
                ships_from_country: brand.ships_from_country,
                is_showroom: brand.is_showroom,
                based_in_country: brand.based_in_country,
                insider_benefits: brand.insider_benefits,
                insider_label: brand.insider_label,
                region_flag_image: brand.region_flag_image,
                avg_brand_review_rating: brand.avg_brand_review_rating,
                product_images: brand.product_images
            }),
            promo_text: brand.brand_promo_string,
            images: [
                brand.image
            ].filter(isNotUndefined),
            brand_promo_label: brand.brand_promo_label,
            featured_brand_promo_label: brand.featured_brand_promo_label,
            lead_time_text: undefined
        };
    };
    ILeanBrandTile.fromIBrand = function(brand) {
        if (!brand) {
            return undefined;
        }
        var _brand_images;
        return {
            brand: IRealLeanBrandTile.IBrand.build({
                name: brand.name,
                is_following: brand.is_following,
                token: brand.token,
                ships_from_country: brand.ships_from_country,
                description: brand.description,
                squared_image: brand.squared_image,
                free_shipping_reason: brand.free_shipping_reason,
                has_new_products: brand.has_new_products,
                is_first_order: brand.is_first_order,
                minimum_order_amount: brand.minimum_order_amount,
                is_highlighted_brand_for_promotional_event: brand.is_highlighted_brand_for_promotional_event,
                is_top_shop: brand.is_top_shop,
                // TODO(danyao.wang): remove this field once BrandTileForCarousel is updated to
                // take an ILeanBrandTile instead of ILeanBrandTile.IBrand.
                based_in: brand.based_in,
                insider_benefits: brand.insider_benefits,
                insider_label: brand.insider_label,
                is_showroom: brand.is_showroom,
                profile_image: brand.profile_image,
                hide_chat: brand.hide_chat,
                brand_reviews_summary: brand.brand_reviews_summary,
                based_in_country: brand.based_in,
                zip_code_protection_enabled: brand.zip_code_protection_enabled
            }),
            promo_text: brand.brand_promo_string,
            images: (_brand_images = brand.images) !== null && _brand_images !== void 0 ? _brand_images : [],
            brand_promo_label: brand.brand_promo_label,
            featured_brand_promo_label: brand.featured_brand_promo_label,
            lead_time_text: undefined
        };
    };
    ILeanBrandTile.fromSearchV2IBrand = function(strictLocalize) {
        return function(brand) {
            if (!brand) {
                return undefined;
            }
            return {
                brand: IRealLeanBrandTile.IBrand.build({
                    name: brand.name,
                    token: brand.token,
                    squared_image: brand.image,
                    description: brand.description,
                    is_following: brand.is_following,
                    free_shipping_reason: brand.free_shipping_reason,
                    minimum_order_amount: brand.minimum_order_amount,
                    has_new_products: brand.has_new_products,
                    is_top_shop: brand.is_top_shop,
                    is_first_order: brand.is_first_order,
                    is_highlighted_brand_for_promotional_event: brand.is_highlighted_brand_for_promotional_event,
                    based_in: brand.based_in_country,
                    ships_from_country: brand.ships_from_country,
                    is_showroom: brand.is_showroom,
                    zip_code_protection_enabled: brand.is_zip_code_protection_enabled,
                    based_in_country: brand.based_in_country,
                    insider_benefits: brand.insider_benefits,
                    insider_label: brand.insider_label,
                    show_location_badging: brand.show_location_badging,
                    region_flag_image: brand.region_flag_image,
                    avg_brand_review_rating: brand.avg_brand_review_rating,
                    product_images: brand.product_images
                }),
                promo_text: brand.highest_tier_promo_description,
                images: [
                    brand.image
                ].concat(_to_consumable_array(brand.product_images)).filter(isNotUndefined),
                brand_promo_label: brand.brand_promo_label,
                featured_brand_promo_label: brand.featured_promo_label,
                lead_time_text: getLeadTimeText(brand.lower_bound_lead_time_days, brand.upper_bound_lead_time_days, strictLocalize)
            };
        };
    };
    ILeanBrandTile.fromLargeBrandTile = function(brand) {
        if (!brand) {
            return undefined;
        }
        return {
            brand: IRealLeanBrandTile.IBrand.build({
                name: brand.name,
                token: brand.token,
                squared_image: brand.image,
                description: brand.description,
                is_following: brand.is_following,
                free_shipping_reason: brand.free_shipping_reason,
                minimum_order_amount: brand.minimum_order_amount,
                has_new_products: brand.has_new_products,
                is_top_shop: brand.is_top_shop,
                is_highlighted_brand_for_promotional_event: brand.is_highlighted_brand_for_promotional_event,
                based_in: brand.based_in_country,
                ships_from_country: brand.ships_from_country,
                is_showroom: brand.is_showroom,
                highlighted_apparel_seasons_for_promotional_event: brand.highlighted_apparel_seasons_for_promotional_event,
                based_in_country: brand.based_in_country,
                insider_benefits: brand.insider_benefits,
                insider_label: brand.insider_label,
                profile_image: brand.profile_image,
                show_location_badging: brand.show_location_badging,
                region_flag_image: brand.region_flag_image,
                product_images: brand.product_images
            }),
            promo_text: brand.brand_promo_string,
            images: [
                brand.image
            ].concat(_to_consumable_array(brand.product_images)).filter(isNotUndefined),
            brand_promo_label: brand.brand_promo_label,
            featured_brand_promo_label: brand.featured_brand_promo_label,
            lead_time_text: undefined
        };
    };
    ILeanBrandTile.fromBoardLeanBrandTile = function(brandTile) {
        var _brandTile_brand;
        return _object_spread_props(_object_spread({}, brandTile), {
            images: brandTile.images.length === 0 ? [
                (_brandTile_brand = brandTile.brand) === null || _brandTile_brand === void 0 ? void 0 : _brandTile_brand.squared_image
            ].filter(isNotUndefined) : brandTile.images
        });
    };
    ILeanBrandTile.fromBrandPromoTile = function(brandPromoTile) {
        var _brandPromoTile_active_brand_promo_collection_promos_, _brandPromoTile_active_brand_promo_collection, _brandPromoTile_active_brand_promo_collection1;
        var _brandPromoTile_active_brand_promo_collection_promos_length;
        return IRealLeanBrandTile.build({
            brand: IRealLeanBrandTile.IBrand.build({
                name: brandPromoTile.name,
                token: brandPromoTile.token,
                squared_image: brandPromoTile.image,
                minimum_order_amount: brandPromoTile.minimum_order_amount,
                is_top_shop: brandPromoTile.is_top_shop,
                is_highlighted_brand_for_promotional_event: brandPromoTile.is_highlighted_brand_for_promotional_event,
                ships_from_country: brandPromoTile.ships_from_country
            }),
            promo_text: (_brandPromoTile_active_brand_promo_collection1 = brandPromoTile.active_brand_promo_collection) === null || _brandPromoTile_active_brand_promo_collection1 === void 0 ? void 0 : (_brandPromoTile_active_brand_promo_collection_promos_ = _brandPromoTile_active_brand_promo_collection1.promos[((_brandPromoTile_active_brand_promo_collection_promos_length = (_brandPromoTile_active_brand_promo_collection = brandPromoTile.active_brand_promo_collection) === null || _brandPromoTile_active_brand_promo_collection === void 0 ? void 0 : _brandPromoTile_active_brand_promo_collection.promos.length) !== null && _brandPromoTile_active_brand_promo_collection_promos_length !== void 0 ? _brandPromoTile_active_brand_promo_collection_promos_length : 0) - 1]) === null || _brandPromoTile_active_brand_promo_collection_promos_ === void 0 ? void 0 : _brandPromoTile_active_brand_promo_collection_promos_.short_description,
            images: brandPromoTile.image ? [
                brandPromoTile.image
            ] : [],
            brand_promo_label: undefined,
            featured_brand_promo_label: undefined,
            lead_time_text: undefined
        });
    };
})(ILeanBrandTile || (ILeanBrandTile = {}));
